"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (props) {
    return _react2.default.createElement(
        "svg",
        { width: "13", height: "9", viewBox: "0 0 13 9", className: "Icon board-shared-users", xmlns: "http://www.w3.org/2000/svg" },
        _react2.default.createElement(
            "g",
            { fill: "#FFF", fillRule: "evenodd" },
            _react2.default.createElement("path", { d: "M4 4c1.103 0 2-.897 2-2 0-1.125-.943-2-2-2S2 .875 2 2c0 1.103.897 2 2 2M7.73 5.128c.466-.147 1.047-.239 1.772-.24 1.793.001 2.712.568 3.148 1.13.262.337.35.672.35.882v.64a.392.392 0 0 1-.031.149c-.073.18-.272.311-.508.311H9v-.414c0-.533-.199-1.154-.577-1.702a3.751 3.751 0 0 0-.692-.756zM9.5 4c.827 0 1.5-.673 1.5-1.5 0-.844-.707-1.5-1.5-1.5S8 1.656 8 2.5C8 3.327 8.673 4 9.5 4M4.002 5C1.948 5 .899 5.73.4 6.452c-.299.434-.4.864-.4 1.134v.824A.613.613 0 0 0 .616 9h6.768A.613.613 0 0 0 8 8.41v-.824c0-.27-.1-.7-.4-1.134C7.102 5.73 6.052 5 4.002 5z" })
        )
    );
}; /*eslint-disable */


//////////////////
// WEBPACK FOOTER
// ./src/client/components/icons/large/jsx/board-shared-users.js
// module id = 1787
// module chunks = 0